import {Badge, Spin, Table} from 'antd'
import React, { useEffect } from 'react'
import {NotificationItem, NotificationItemStore} from 'src/stores/systemNotifications/notification-store'
import {WithTranslation, withTranslation} from 'react-i18next'
import NotificationView from './notification-Item'
import {ItemModel, Query} from '../../core/stores/dataStore'
import {connect} from 'redux-scaffolding-ts'
import { PaginationConfig } from 'antd/lib/pagination'

export interface NotificationListProps extends WithTranslation {
  reload: number
  setNotificationCount: (count: number) => void
  visible: boolean
}
export interface NotificationListState {
  query: Query,
  wasOpen: boolean,
  busy: boolean
  pagination: PaginationConfig,
}
@connect(["notifications", NotificationItemStore])
class NotificationList extends React.Component<NotificationListProps, NotificationListState> {

  constructor(props: any) {
    super(props)
    this.state = {
      query: {
        searchQuery: '',
        orderBy: [{ field: 'creationTime', direction: 'Descending', useProfile: false }],
        skip: 0,
        take: 10,
      } as Query
      ,
      wasOpen: false,
      busy: false,
      pagination: {}
    }
  }

  componentWillMount() {
    this.load()
  }

  private async load( query? : any) {
    this.setState({ busy: true })
    await this.notificationStore.getAllAsync(query ?? this.state.query)
    this.props.setNotificationCount(this.notificationStore.state.items.filter((x) => !x.item.readed).length)
    this.setState({ busy: false })

  };

  private get notificationStore() {
    return (this.props as any).notifications as NotificationItemStore
  }

  private async setNotificationReadStatus() {
    this.setState({ busy: true })
    await this.notificationStore.SetReadStatus()
    await this.load()
    this.setState({ busy: false })
  };

  componentWillReceiveProps(nextProps: NotificationListProps) {

    if (this.props.reload > 0 && this.props.reload != nextProps.reload) {
      this.load()
    }
    if (this.props.visible != nextProps.visible) {
      this.setState({ wasOpen: nextProps.visible })
      if (!nextProps.visible)
        this.setNotificationReadStatus()
      else this.load()
    }

  }

  private async remove(not: NotificationItem) {
    this.setState({ busy: true })
    await this.notificationStore.delete(not.id)
    await this.load()
    this.setState({ busy: false })

  }

  private async clear() {
    this.setState({ busy: true })
    await this.notificationStore.deleteAll()
    await this.load()
    this.setState({ busy: false })
    }

    handleTableChange = async (pagination: PaginationConfig, filters: any, sorter: any) => {
      let newQuery = {
        searchQuery: '',
        orderBy: [{ field: 'creationTime', direction: 'Descending', useProfile: false }],
        skip: pagination.current ? (pagination.current - 1) * (pagination.pageSize ?? 10) : 0,
        take: pagination.pageSize ?? 10,
      } as Query
      this.setState({query: newQuery})
      await this.load(newQuery)
    };
    

    render(): React.ReactNode {
        const columns = [
            {
                title: "",
                key: "notifications",
                render: (record: ItemModel<NotificationItem>) => (
                    <NotificationView key={record.item.id} notification={record.item} removeNotification={() => this.remove(record.item)} />
                ),
            }
        ];

    const { t } = this.props

    if (!this.notificationStore.state.items || this.notificationStore.state.items.length === 0) {
      return <h2>{t('No Notifications')}</h2>
    }
    return (<React.Fragment>
      <div data-testid="openNotificationsButton" className="notification-content">
        <Spin spinning={this.notificationStore.state.isBusy || this.state.busy}>
          <Badge count={this.notificationStore.state.items.filter((x) => !x.item.readed).length}>
            <h2>{t('Notifications')}</h2>
          </Badge>
          <span style={{ fontSize: '16px', marginLeft: '10px' }}>{'(' + this.notificationStore.state.count + ')'} </span>
          <button type='button' className='ant-btn ant-btn-default' style={{ float: 'right', marginRight: 40 }} onClick={() => this.clear()}> {t('Clear All')} </button>
                <Table 
                  columns={columns} 
                  dataSource={this.notificationStore.state.items} 
                  key="uniqueId1"
                  pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'], total:  this.notificationStore.state.count}}
                  onChange={this.handleTableChange}
           />
        </Spin>
      </div>
    </React.Fragment>)
  }

};

export default withTranslation()(NotificationList)
